import React from "react";
import PropTypes from "prop-types";

const UserIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 14}
      height={height || 14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11.0827 12.25V11.0833C11.0827 9.79553 10.0372 8.75 8.74935 8.75H5.24935C3.96155 8.75 2.91602 9.79553 2.91602 11.0833V12.25"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.16667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66602 4.08333C4.66602 5.37113 5.71155 6.41667 6.99935 6.41667C8.28715 6.41667 9.33268 5.37113 9.33268 4.08333C9.33268 2.79553 8.28715 1.75 6.99935 1.75C5.71155 1.75 4.66602 2.79553 4.66602 4.08333V4.08333"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.16667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

UserIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

UserIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default UserIcon;
